import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metodology-page',
  templateUrl: './metodology-page.component.html',
  styleUrls: ['./metodology-page.component.css']
})
export class MetodologyPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
